export const GET_EMPLOYEE = 'GET_EMPLOYEE'